import NoShowChargeAlert from "components/alerts/no-show-charge-alert";
import NoShowAlert from "components/details-form/no-show-alert";
import PrepaymentAlert from "components/details-form/prepayment-alert";
import WaitListNoShowAlert from "components/wait-list/wait-list-no-show-alert";
import WaitListPrepaymentAlert from "components/wait-list/wait-list-prepayment-alert";

interface BookingAlertManagerProps {
    isNoShow: boolean;
    isPrepayment: boolean;
    isWaitList: boolean;
    hasNoShowCharge?: boolean;
    isBookingCanceled?: boolean;
    shouldShowConfirmWaitListBtn?: boolean;
    detailsForm?: boolean; // Optional prop to indicate if this is used in a details form context
}

export const BookingAlertManager = ({
    isNoShow,
    isPrepayment,
    isWaitList,
    hasNoShowCharge = false,
    isBookingCanceled = false,
    shouldShowConfirmWaitListBtn = false,
    detailsForm,
}: BookingAlertManagerProps) => {
    if (hasNoShowCharge) {
        return <NoShowChargeAlert />;
    }

    if (isNoShow && isWaitList && !shouldShowConfirmWaitListBtn && !isBookingCanceled) {
        return <WaitListNoShowAlert />;
    }

    if (isPrepayment && isWaitList && !shouldShowConfirmWaitListBtn && !isBookingCanceled) {
        return <WaitListPrepaymentAlert />;
    }

    if (isNoShow && (shouldShowConfirmWaitListBtn || detailsForm)) {
        return <NoShowAlert />;
    }

    if (isPrepayment && (shouldShowConfirmWaitListBtn || detailsForm)) {
        return <PrepaymentAlert />;
    }

    return null;
};
